import { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { BellIcon } from '@heroicons/react/24/outline'
import { announcementService, Announcement } from '@/services/announcementService'

/**
 * 通知中心：头部铃铛入口。
 *
 * 拉取系统公告（/announcement）；存在启用中的公告时铃铛显示红点，
 * 点击弹出公告详情。首次满足展示条件时自动弹出一次（按 announcementService 的去重规则）。
 */
export default function NotificationCenter() {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    let mounted = true
    announcementService
      .getAnnouncement()
      .then((a) => {
        if (!mounted || !a) return
        setAnnouncement(a)
        // 满足条件则自动弹出一次并标记已读
        if (announcementService.shouldShowAnnouncement(a)) {
          setOpen(true)
          announcementService.markAsShown(a)
        }
      })
      .catch(() => {
        /* 公告获取失败不影响主流程 */
      })
    return () => {
      mounted = false
    }
  }, [])

  const hasActive = !!announcement && announcement.enabled

  return (
    <>
      <button
        type="button"
        className="header-icon-btn"
        aria-label="通知"
        title="通知公告"
        onClick={() => setOpen(true)}
        style={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 6,
        }}
      >
        <BellIcon style={{ width: 18, height: 18 }} />
        {hasActive && (
          <span
            style={{
              position: 'absolute',
              top: 4,
              right: 4,
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: '#ff4d4f',
            }}
          />
        )}
      </button>

      <Modal
        open={open}
        title={announcement?.title || '通知公告'}
        footer={null}
        onCancel={() => setOpen(false)}
      >
        {hasActive ? (
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{announcement!.content}</div>
        ) : (
          <div style={{ color: 'var(--text-tertiary)' }}>暂无新公告</div>
        )}
      </Modal>
    </>
  )
}
